<template>
  <div
    class="my-20 lg:my-50 xl:my-60"
    :class="{
      'min-h-[30px]': isEditing,
      'bk-paragraph-region-affected': options.isHidden,
    }"
  >
    <div
      v-if="options.teaserType === 'article'"
      class="grid md:grid-cols-2 lg:grid-cols-3 gap-30"
    >
      <ArticleTeaser v-for="(row, index) in rows" :key="index" v-bind="row" />
    </div>
    <div
      v-else
      class="grid md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-20 lg:gap-30"
    >
      <NodeTile
        v-for="(row, index) in rows"
        :key="index"
        :label="row.label"
        :url="row.url"
        :icon="row.icon"
        :color="colorName"
      />
    </div>
    <div v-if="link" class="text-center mt-30">
      <ButtonStyle v-slot="{ classes }">
        <DrupalLink :to="link.uri?.path" :class="classes">
          {{ link.title || $texts('showAll', 'Alle anzeigen') }}
        </DrupalLink>
      </ButtonStyle>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {
  ArticleTeaserArticleFragment,
  ArticleTeaserFragment,
  ArticleTeaserPressReleaseFragment,
  NodeTileFragment,
  NodeTilePageFragment,
  ParagraphViewFragment,
  SiteColor,
} from '#graphql-operations'
import { falsy, narrowTypeByProperty } from '~/helpers/type'

const { options, isEditing } = defineBlokkli({
  bundle: 'view',
  globalOptions: ['teaserColor', 'isHidden'],
  chunkName: 'rare',
  options: {
    teaserType: {
      type: 'radios',
      label: 'Teaserdarstellung',
      options: {
        article: 'Artikel',
        card: 'Teaser',
      },
      default: 'card',
    },
  },
})

const props = defineProps<{
  viewResult: ParagraphViewFragment['viewResult']
  link?: ParagraphViewFragment['link']
}>()

type UnionRowType = ArticleTeaserFragment &
  ArticleTeaserArticleFragment &
  ArticleTeaserPressReleaseFragment &
  NodeTileFragment &
  NodeTilePageFragment

const rows = computed<UnionRowType[]>(() => {
  return (props.viewResult?.rows || [])
    .filter((v) => narrowTypeByProperty(v, 'id'))
    .filter(falsy) as UnionRowType[]
})

const colorName = computed(() => {
  return options.value.teaserColor as SiteColor
})
</script>
